<!--
 * @version: V1.0.0
 * @Date: 2022-12-05 15:18:22
 * @LastEditors: lzq
 * @LastEditTime: 2023-10-11 09:54:03
 * @company: 睿展数据
 * @FilePath: \udi-web\src\pages\system\user\ResetPassword.vue
 * @Descripttion:
-->
<template>
  <el-dialog
    :visible="visible"
    width="30%"
    @close="close"
    title="重置密码"
    :close-on-click-modal="false"
  >
    <div>
      <el-form :model="form" ref="form" :rules="rules">
        <div class="faci-box" style="width: 80%; min-height: auto; margin: 0 auto">
          <div class="group-box">
            <div class="box-body">
              <el-form-item :label="`请输入：${user.nickName}的新密码`" prop="password">
                <el-input
                  type="password"
                  v-model="form.password"
                  maxlength="20"
                  placeholder="请输入新密码"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" class="common-btn" @click="submit">确定</el-button>
      <el-button type="default" @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { resetUserPwd } from '@/api/system/user.js'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    }
  },

  data() {
    const validatePassword = (rule, value, callback) => {
      const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/ // matches 11-digit mobile numbers starting with 1
      if (value && !passwordPattern.test(value)) {
        callback(new Error('请输入6位数以上大小写字母+数字的密码'))
      } else {
        callback()
      }
    }

    return {
      currentUser: {},
      form: {
        password: ''
      },
      rules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { required: true, validator: validatePassword, trigger: ['blur', 'change'] }
        ]
      }
    }
  },

  methods: {
    submit() {
      this.$refs.form.validate().then(async (valid) => {
        console.log(this.user.userId)
        console.log(this.form.password)
        if (!valid) return false
        const { code, msg } = await resetUserPwd(this.user.userId, this.form.password)
        if (code === 200) {
          this.$message({
            message: '重置密码成功！',
            type: 'success'
          })
        } else {
          this.$message.error(msg)
        }
        this.close()
      })
    },

    close() {
      this.form.password = ''
      this.$emit('close')
    }
  }
}
</script>
